/* Mobile sticky add-to-cart bar.
   Shows the bar once the real buy button scrolls out of view; the bar's
   button submits the main product form (form= attribute), so variant
   selection and Dawn's AJAX add flow are untouched. Desktop hidden via CSS. */
(function () {
  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    // never activate inside the quick-add modal — its ATC is already in view
    if (bar.closest('quick-add-modal')) return;

    var sectionId = bar.getAttribute('data-section-id');
    var mainSubmit = document.querySelector('#ProductSubmitButton-' + sectionId);
    var priceEl = document.getElementById('price-' + sectionId);
    var barButton = bar.querySelector('.sticky-atc__button');
    var barPrice = bar.querySelector('.sticky-atc__price');
    if (!mainSubmit || !barButton) return;

    // Mirror sold-out / disabled state + label from the real button.
    function syncButton() {
      var span = mainSubmit.querySelector('span');
      var barSpan = barButton.querySelector('span');
      if (span && barSpan) barSpan.textContent = span.textContent.trim();
      if (mainSubmit.hasAttribute('disabled') || mainSubmit.getAttribute('aria-disabled') === 'true') {
        barButton.setAttribute('disabled', '');
      } else {
        barButton.removeAttribute('disabled');
      }
    }

    // Mirror the (variant-aware) sale price from the price block.
    function syncPrice() {
      if (!priceEl || !barPrice) return;
      var sale = priceEl.querySelector('.price-item--sale.price-item--last') ||
                 priceEl.querySelector('.price-item--regular');
      if (sale) barPrice.textContent = sale.textContent.trim();
    }

    syncButton();
    syncPrice();

    var observer = new MutationObserver(function () {
      syncButton();
      syncPrice();
    });
    observer.observe(mainSubmit, { attributes: true, childList: true, subtree: true });
    if (priceEl) observer.observe(priceEl, { childList: true, subtree: true });

    var io = new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        var pastBuyBox = entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('sticky-atc--visible', !visible && pastBuyBox);
      },
      { threshold: 0 }
    );
    io.observe(mainSubmit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
